import request from "@/utils/request";

// 获取公司开票信息
export const getCompanyInfo = query => {
  return request({
    url: "/venue/parkCompany/info/miniProgram/list",
    method: "GET",
    params: query
  });
};
// 查询未开票公司订单信息
export const getComapnyInvoiceList = data => {
  return request({
    url: "/venue/vehicle/invoiceApply/company/needApplyList",
    method: "POST",
    data
  });
};

// 查询未开票订单信息
export const getInvoiceList = data => {
  return request({
    url: "/venue/vehicle/invoiceApply/needApplyList",
    method: "POST",
    data
  });
};

// 添加发票抬头信息
export const addInvoinceInfo = data => {
  return request({
    url: "/venue/vehicle/invoiceApply/addInvoinceInfo",
    method: "POST",
    data
  });
};

// 开票申请-个人-诺诺
export const submitInvoice = data => {
  return request({
    url: "/venue/vehicle/invoiceApply/doApply",
    method: "POST",
    data
  });
};

// 开票申请-企业-诺诺
export const invoiceApplyCompany = data => {
  return request({
    url: "/venue/vehicle/invoiceApply/company/doApply",
    method: "POST",
    data
  });
};

// 开票申请-个人-票通
export const doApplyPiaoTongPrivate = data => {
  return request({
    url: "/venue/vehicle/invoiceApply/doApplyPiaoTongPrivate",
    method: "POST",
    data
  });
};
